export default "__VITE_ASSET__C5U66oQ7__"